<template>
    <div data-cy="main-wrapper" v-if="isVisible" id="control-tva-container">
        <v-btn-primary
            v-if="isTaxControlButtonVisible"
            block
            data-cy="main-button"
            elevation="0"
            class="rounded-lg gradient mt-2"
            @click="openTaxControlCreateDialog()"
            :disabled="disableMainButton"
            size="large"
        >
            {{ $t("control-tva.main-button") }}
        </v-btn-primary>
        <oss-dialog
            v-model="isTaxDialogVisible"
            height="90vh"
            width="60vw"
            persistent
            @close="closeTaxControlDialog()"
            maxWidth="80vw"
            :title="getDialogTitle()"
        >
            <template v-if="step === 'date-picker'">
                <oss-date-picker-filled v-model="selectedDate"></oss-date-picker-filled>
            </template>
            <template v-if="step === 'table'">
                <ControlTVATable :inputDate="selectedDate.toISOString()"></ControlTVATable>
            </template>
        </oss-dialog>
    </div>
</template>
<script lang="ts">
import { Component, Prop, toNative, Vue, Watch } from "vue-facing-decorator";
import ControlTVATable from "./ControlTVATable.vue";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";

@Component({
    name: "ControlTVA",
    components: { ControlTVATable },
})
export class ControlTVAComponent extends Vue {
    /**
     * Controls the visibility of the content.
     * @default true
     */
    @Prop({ default: true }) isVisible!: boolean;

    /**
     * Disables the main button.
     * @default false
     */
    @Prop({ default: false }) disableMainButton!: boolean;

    // Reactive data
    isTaxDialogVisible = false;
    selectedDate: Date;
    step: "date-picker" | "table" = "date-picker";

    @Watch("selectedDate")
    goToControlTVATable(): void {
        if (!this.selectedDate) return;
        this.step = "table";
    }
    closeTaxControlDialog(): void {
        this.step = "date-picker";
        this.selectedDate = undefined;
        this.isTaxDialogVisible = false;
    }

    /**
     * Computed property to determine the visibility of the tax control button.
     *
     * @returns {boolean} - Returns `true` if the company is not subject to VAT, making the button visible; otherwise, `false`.
     *
     */
    get isTaxControlButtonVisible() {
        const company = this.$store.getters.getCompany(this.$store.state.user.selectedCompany.id);
        if (company && isNotSubjectToVAT(company.vatSystem)) {
            return false;
        } else {
            return true;
        }
    }
    openTaxControlCreateDialog(): void {
        this.isTaxDialogVisible = true;
    }

    getDialogTitle(): string {
        if (this.step === "date-picker") return this.$t("control-tva.dialog-title-date-picker");
        else if (this.step === "table")
            return this.$t("control-tva.dialog-title-table", {
                date: this.selectedDate?.toLocaleDateString("fr-FR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                }),
            });
    }
}
export default toNative(ControlTVAComponent);
</script>
<style lang="scss" scoped></style>
